import { createContext, useContext, useState } from "react";

const EnquiryContext = createContext(null);
export const useEnquiry = () => useContext(EnquiryContext);

const lineFor = (name, price) => `${name}${price ? ` - ${price}` : ""}`;

export function EnquiryProvider({ children }) {
  const [serviceText, setServiceText] = useState("");

  const hasService = (name, price) =>
    serviceText.split("\n").some((l) => l.trim() === lineFor(name, price));

  const toggleService = (name, price) => {
    const line = lineFor(name, price);
    setServiceText((prev) => {
      const lines = prev ? prev.split("\n") : [];
      if (lines.some((l) => l.trim() === line)) {
        return lines.filter((l) => l.trim() !== line).join("\n");
      }
      const cleaned = lines.filter((l) => l.trim() !== "");
      return [...cleaned, line].join("\n");
    });
  };

  return (
    <EnquiryContext.Provider value={{ serviceText, setServiceText, hasService, toggleService }}>
      {children}
    </EnquiryContext.Provider>
  );
}
